import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')  
  },
  {  
    path: '/news',  
    name: 'news',  
    component: () => import('../views/NewsView.vue')  
  },
  {  
    path: '/chanJiao',  
    name: 'chanJiao',  
    component: () => import('../views/ChanJiaoView.vue')  
  },
  {  
    path: '/about',  
    name: 'about',  
    component: () => import('../views/AboutView.vue')  
  },
  {  
    path: '/contact',  
    name: 'contact',  
    component: () => import('../views/ContactView.vue')  
  },
  {  
    path: '/largeModel',  
    name: 'largeModel',  
    component: () => import('../views/largeModelView.vue')  
  },
  {
    path: '/newsDetails/:id', 
    name: 'newsDetails',
    component: () => import('../views/newsDetailsView.vue')
  },


  // product文件夹下面有四个vue文件分别是IntegrationEdu，BlockChain，LargeModel，DataPlatform
  // 产品及解决方案   
  {  
    path: '/product/integrationEdu',  
    name: 'IntegrationEdu',
    meta: {
      type: 'product'
    },
    component: () => import('../views/product/IntegrationEdu.vue')  
  },
  {  
    path: '/product/blockChain',  
    name: 'BlockChain',
    meta: {
      type: 'product'
    },
    component: () => import('../views/product/BlockChain.vue')  
  },
  {  
    path: '/product/largeModel',  
    name: 'LargeModel',
    meta: {
      type: 'product'
    },
    component: () => import('../views/product/LargeModel.vue')  
  },
  {  
    path: '/product/dataPlatform',  
    name: 'DataPlatform',
    meta: {
      type: 'product'
    },
    component: () => import('../views/product/DataPlatform.vue')  
  },
  {  
    path: '/product/dataCenter',  
    name: 'Datacenter',
    meta: {
      type: 'product'
    },
    component: () => import('../views/product/DataCenter.vue')  
  },
  {  
    path: '/product/AIdiagnosis',  
    name: 'AIdiagnosis',
    meta: {
      type: 'product'
    },
    component: () => import('../views/product/AIdiagnosis.vue')  
  },
  {  
    path: '/product/AIHospitalMgmt',  
    name: 'AIHospitalMgmt',
    meta: {
      type: 'product'
    },
    component: () => import('../views/product/AIHospitalMgmt.vue')  
  },

// 按照以上路径配置下面的文件夹路径
  // newsDetails文件夹下面有四个vue文件分别是newsDetails1，newsDetails2，newsDetails3

  // //新闻资讯详情
  // {
  //   path: '/news/newsDetails',
  //   name: 'NewsDetails',
  //   meta: {
  //     type: 'news'
  //   },
  //   component: () => import('../views/news/NewsDetails.vue')
  // }
]

const router = new VueRouter({
  routes
})

router.afterEach(() => {
  // 每次路由跳转后滚动到顶部
  window.scrollTo(0, 0);
});

export default router
